import '@pes-ui/components/dist/collection'

const pesAppTest = JSON.parse(localStorage.getItem('pesAppTest'));

if (pesAppTest) {
  const { dir = 'not_set' } = pesAppTest;
  document.dir = dir !== 'not_set' ? dir : document.dir;
}